import React, { useEffect, useState } from "react";
import FrontEndTable from "../../components/table/FrontEndTable";
import { useApiClient } from "../../shared/customHooks";
import UsersTable from "../../shared/tableObjects/usersTable";
import { Header } from "../../components/header/Header";
import { PageHeader } from "../../components/header/PageHeader";
import { Button } from "primereact/button";
import { Link } from "react-router";
import { useGlobalContext } from "../../shared/GlobalContext";

export default function ManageUsers() {
  const [users, setUsers] = useState<any[]>([]);
  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const { accountInfo } = useGlobalContext();

  useEffect(() => {
    fetchData("GetAllUsers").then((res) => {
      setUsers(res.data);
    });
  }, []);

  const headerText = [
    {
      class: "flex items-center mt-0",
      value: "Manage Users",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    },
  ];

  return (
    <>
      <Header />
      <PageHeader headerText={headerText} icon={"icon"} />
      <div className="p-5">
        {" "}
        <FrontEndTable
          columns={UsersTable}
          data={users}
          header=""
          TopRightContent={() =>
            accountInfo.IsRootOrManager && (
              <Link to="new">
                <Button label="Add User" className="form-button mt-0 " />
              </Link>
            )
          }
        />
      </div>{" "}
    </>
  );
}
